module.exports = __webpack_public_path__ + "static/media/uspolo1.cf8749cd.jpg";